import { colors } from '@amazd/common/static';
import { makeStyles } from '@mui/styles';
import { buttonProgress } from 'styles/theme';

const useStyles = makeStyles(() => ({
  root: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    backgroundSize: 'cover',
    cursor: 'pointer',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    overflow: 'hidden',

    '& span': {
      width: '100%',
      height: '100%',
      display: 'none',

      justifyContent: 'center',
      alignItems: 'center',

      color: '#ffffff',
    },
    '&:hover span': {
      display: 'flex',
      background: 'rgba(0, 0, 0, 0.4)',
    },
  },

  hoverIcon: {
    width: '32px',
    height: '32px',
  },

  modal: {
    '& .MuiDialog-paper': {
      padding: '40px 48px',
      width: 624,
    },
  },
  modalTitle: {
    padding: 0,
    fontSize: '18px',
  },
  modalContent: {
    marginTop: 40,
    padding: '0 !important',
  },
  modalError: {
    marginTop: 16,
  },
  modalActions: {
    marginTop: 56,
    padding: 0,
  },
  modalCloseButton: {
    position: 'absolute',
    right: 16,
    top: 16,
    color: colors.black,
  },
  modalSubmit: {
    paddingLeft: '24px',
    paddingRight: '24px',
  },
  buttonProgress,
}));

export default useStyles;
